import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shadow from '../../styles/shadows';

var Card = /*#__PURE__*/function (_Component) {
  _inherits(Card, _Component);

  var _super = _createSuper(Card);

  function Card() {
    _classCallCheck(this, Card);

    return _super.apply(this, arguments);
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      var styles = require('./Card.scss');

      var elevationStyle = shadow[this.props.elevation];
      return /*#__PURE__*/React.createElement("div", {
        className: styles.card,
        style: elevationStyle
      }, this.props.children);
    }
  }]);

  return Card;
}(Component);

_defineProperty(Card, "propTypes", {
  children: PropTypes.node.isRequired,
  elevation: PropTypes.string.isRequired
});

_defineProperty(Card, "defaultProps", {
  elevation: 'elevation1'
});

_defineProperty(Card, "styleguide", {
  title: 'Card',
  sample_code: '<Card children={<span>Yo</span> />',
  props: {
    children: '<span>yo</span>'
  }
});

export { Card as default };